const SaleAgentCardSkeleton = () => {
  return (
    <div className="border rounded-2xl p-3 space-y-3 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-center gap-2">
          <div className="w-9 h-9 bg-gray-200 rounded-full object-cover animate-pulse" />
          <div className="bg-gray-200 w-28 h-5 rounded-lg animate-pulse" />
        </div>
        <i className="icon-nameArrow---Left-2 text-xl text-gray-700" />
      </div>

      <div className="flex items-center mr-2">
        <div className="bg-gray-200 w-4 h-4 rounded-full animate-pulse" />
        <div className="bg-gray-200 w-full h-3 rounded-lg mr-2 animate-pulse" />
      </div>

      <div className="flex items-center mr-2">
        <div className="bg-gray-200 w-4 h-4 rounded-full animate-pulse" />
        <div className="bg-gray-200 w-20 h-3 rounded-lg mr-2 animate-pulse" />
      </div>
    </div>
  );
};

export default SaleAgentCardSkeleton;
